import { FC, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from '../../../redux/reducer/store';

import { actionGetProjectsList } from '../../../redux/action/projects/actionProjects';
import { actionGetRoutes } from '../../../redux/action/projects/actionRoutes';
import {
  reducerCreateVacancyInputValues,
  reducerHandleErrors,
  reducerAddRoutesListOptions,
} from '../../../redux/reducer/recruiting/reducers/reducerCreateVacancy';

import {
  reducerRoutesInputValues, reducerGetRoutes
} from '../../../redux/reducer/projects/reducers/reducerRoutesList';

import Select from '../../custom/select/select';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Loader from '../../custom/loader/loader';

import clsx from 'clsx';

import styles from './recruiting.module.scss';
import { IRoutesOptions } from '../../../types/routeInterfaces';

const typeFilter = [
  { value: 'ON_ROUTE', label: 'Связана с маршрутом' },
  { value: 'NO_ROUTE', label: 'Не связана с маршрутом' },
  { value: 'LOST_ROUTE', label: 'Потеряна связь с маршрутом' },
  { value: 'PARTIAL_ROUTE', label: 'Частично связана с маршрутом' },
];
const TableVacancyCreate: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();
  const [selectedActions, setSelectedActions] = useState<IRoutesOptions[]>([]);
  const [selectedActionsProjects, setSelectedActionsProjects] = useState<{ id: number, name: string }[]>([]);
  const [currentProject, setCurrentProject] = useState<{ id: number, name: string }>()
  const {
    projects,
    limit,
    pages,
  } = useSelector((state: any) => state.projects.projects);

  const { routesInputValues } = useSelector((state: any) => state.projects.routes);
  const { vacancyCreateInputValues, errors, routesListOptions } = useSelector(
    (state: any) => state.recruiting.createVacancy
  );
  const {
    data: routes,
    page,
  } = useSelector((state: any) => state.projects.routes);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
  const projectsArr = projects.map((obj: { id: number, name: string }) => {
    return { label: obj.name, value: obj };
  });

  const [isPending, setIsPending] = useState<boolean>(false);
  const newRoutesListOptions = id ? routesListOptions : routesListOptions && routesListOptions.map((el: { label: number, value: IRoutesOptions }) => {
    return { value: el.value, label: `${el.value.routeNo} ${el.value.project.name}` };
  });

  function getRoutes() {
    setIsPending(true);
    dispatch(reducerRoutesInputValues({ ...routesInputValues, canBeAttachedToVacancy: true }));
    dispatch(reducerGetRoutes({ data: [] }));
    dispatch(actionGetRoutes(limit, page)).then(() => {
      dispatch(reducerRoutesInputValues({ ...routesInputValues, canBeAttachedToVacancy: null }))
      setIsPending(false);
    });
  };

  const selectChange = (event: { value: string, label: string }, name: string) => {
    const value = event.value;
    if (value === 'NO_ROUTE' || value === 'LOST_ROUTE') {
      const { routesNo, ...temp } = vacancyCreateInputValues;
      const newObject = { ...temp, [name]: value }
      dispatch(reducerCreateVacancyInputValues(newObject));
    } else {
      dispatch(reducerCreateVacancyInputValues({ ...vacancyCreateInputValues, 'type': value, }));
      if ((value !== 'NO_ROUTE' && value !== 'LOST_ROUTE') &&
        (currentProject || vacancyCreateInputValues?.projects?.length > 0)) {
        getRoutes();
      }
    }
  };

  useEffect(() => {
    if (selectedActions && selectedActions?.length > 0) {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, routesNo: selectedActions
      }));
    } else {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, routesNo: null
      }));
    }
    // eslint-disable-next-line
  }, [selectedActions]);

  useEffect(() => {
    if (selectedActionsProjects && selectedActionsProjects?.length > 0) {
      const tempInputValues = { ...vacancyCreateInputValues };
      delete tempInputValues.projectRoutes;
      delete tempInputValues.routesNo;
      setSelectedActions([]);
      dispatch(reducerCreateVacancyInputValues({
        ...tempInputValues, projects: selectedActionsProjects, routesNo: []
      }));
      dispatch(reducerHandleErrors([]));
      if ((vacancyCreateInputValues.type !== 'NO_ROUTE' && vacancyCreateInputValues.type !== 'LOST_ROUTE')) {
        getRoutes();
      }
    } else {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, projects: null
      }))
    }
    // eslint-disable-next-line
  }, [selectedActionsProjects]);

  useEffect(() => {
    if (projects.length === 0) {
      setIsPending(true);
      dispatch(actionGetProjectsList(actualLimit, pages)).then(() => {
        setIsPending(false);
      });
    }
  }, [actualLimit, dispatch, pages, projects]);

  useEffect(() => {
    if (errors && errors.length > 0 && vacancyCreateInputValues.type) {
      const temp = errors.filter((err: string) => err !== 'errorType');
      dispatch(reducerHandleErrors(temp));
    }
    if (errors && errors.length > 0 && vacancyCreateInputValues.project) {
      const temp = errors.filter((err: string) => err !== 'errorProject');
      dispatch(reducerHandleErrors(temp));
    }
    if (errors && errors.length > 0 && vacancyCreateInputValues.routesNo) {
      const temp = errors.filter((err: string) => err !== 'errorRoutesNo');
      dispatch(reducerHandleErrors(temp));
    }
    // eslint-disable-next-line
  }, [vacancyCreateInputValues]);

  useEffect(() => {
    if (id) {
      const currentProject = projects.filter((el: { id: number, name: string }) => el.id === parseInt(id))[0];
      if(currentProject) {
        setCurrentProject(currentProject);
        dispatch(reducerCreateVacancyInputValues(
          {
            ...vacancyCreateInputValues,
            project: currentProject.project
          }
        ));
      }
    }
    // eslint-disable-next-line
  }, [id, projects]);

  useEffect(() => {
    dispatch(reducerAddRoutesListOptions({ routes, vacancyCreateInputValues }));
  }, [dispatch, routes, vacancyCreateInputValues]);

  useEffect(() => {
    if (!vacancyCreateInputValues.projects && currentProject) {
      dispatch(reducerCreateVacancyInputValues({ ...vacancyCreateInputValues, projects: [currentProject] }));
    }
    // eslint-disable-next-line
  }, [currentProject]);

  return (
    <>
      <div className='loader__wrapper'>{isPending && <Loader />}</div>
      <div className='createVacancyTable'>
        <div className={styles.tableWrapper}>
          <div>
            <div className={styles.vacancyBlock}>
              <span className='section__title'>Проект</span>
              <form action=''>

                <div className={clsx(styles.subBlock, styles.subBlock_long)}>
                  <div className={styles.subBlock__left}>
                    <span className={styles.blockTitle}>Тип вакансии</span>
                  </div>
                  <div className={styles.subBlock__right}>
                    <div className={styles.filterInput}>
                      <Select
                        defaultValue='NO_ROUTE'
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'type')
                        }
                        options={typeFilter.map((el: { value: string, label: string }) => ({
                          value: el.value,
                          label: el.label,
                        }))}
                        className={clsx(
                          styles.filterSelect,
                          errors && errors.includes('errorType') && styles.error
                        )}
                        placeholder='Не связана с маршрутом'
                        name='type'
                      />
                    </div>
                  </div>
                </div>

                <div className={clsx(styles.subBlock, styles.subBlock_long)}>
                  <div className={styles.subBlock__left}>
                    <span className={styles.blockTitle}>Проект</span>
                  </div>
                  <div className={styles.subBlock__right}>
                    {!currentProject ? (
                      <div className={clsx('reports__region_block')}>
                        <CustomMultiSelect
                          pageName='createVacancy'
                          setState={setSelectedActionsProjects}
                          options={projectsArr}
                          placeholder='Выберите'
                          name="projects"
                          inputValues={{ projects: vacancyCreateInputValues.projects }}
                          reducer={reducerCreateVacancyInputValues}
                          action={() => { }}
                          activeOptions={selectedActionsProjects}
                          classNames={errors && errors.includes('errorProject')}
                        />
                      </div>) : (
                      <div className={styles.subBlock__right__text}>
                        {currentProject && currentProject?.name}
                      </div>
                    )}
                  </div>
                </div>

                {(!(vacancyCreateInputValues?.type === 'NO_ROUTE' ||
                  vacancyCreateInputValues?.type === 'LOST_ROUTE') && (currentProject || vacancyCreateInputValues.projects)) &&
                  <div className={clsx(styles.subBlock, styles.subBlock_long)}>
                    <div className={styles.subBlock__left}>
                      <span className={styles.blockTitle}>Маршрут</span>
                    </div>
                    {routesListOptions.length > 0
                     ? <div className={styles.subBlock__right}>
                     <div className={clsx('reports__region_block')}>
                        <CustomMultiSelect
                          pageName='createVacancy'
                          setState={setSelectedActions}
                          options={newRoutesListOptions}
                          placeholder='Выберите'
                          name="actions"
                          inputValues={{ actions: vacancyCreateInputValues.routesNo }}
                          reducer={reducerCreateVacancyInputValues}
                          action={() => { }}
                          activeOptions={vacancyCreateInputValues.routesNo}
                          classNames={errors && errors.includes('errorRoutesNo')}
                        />
                      </div>
                    </div>
                    : <span className='section__title'>Нет маршрутов для выбора</span>}
                  </div>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableVacancyCreate;
